import {observable, action, runInAction, computed} from 'mobx'
import {get, json} from '../../../../utils/ajax'
import {message} from "antd/lib/index";

class CMSPageStore {

    @observable list
    @observable pagination
    @observable loading
    @observable modal
    @observable forms
    @observable search
    @observable initModul

    constructor() {
        this.list = []
        this.pagination = {}
        this.loading = false
        this.modal = 'hide'
        this.forms = {}
        this.search = {}
        this.initModul = false
    }

    /**
     * 新闻页面列表 + name查询
     * 分页
     */
    @action
    initListPage = async (page) => {
        runInAction(() => {
            this.loading = true
        })
        if (page) {
            page--
        } else if (this.pagination.page) {
            page = this.pagination.page - 1
        } else {
            page = 0
        }
        // 构建查询参数
        let search = {}
        Object.keys(this.search).forEach(key => {
            search[`search.${key}`] = this.search[key] ? this.search[key] : ''
        })
        search.page = page
        search.size = 10
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/cms/page/list`,search)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.list = res.content.map(item => {
                return {
                    id: item.id,
                    name: item.name,
                    createTime: item.createTime
                }
            })
            this.pagination = {
                total: res.totalElements,
                results: res.size,
                page: res.number + 1,
            }
            this.loading = false
        })
    }

    /**
     * 显示模式
     */
    @action showModal = (flag) => {
        runInAction(() => {
            this.loading = true
            this.modal = flag ? 'show' : 'hide'
            this.loading = false
        })
    }

    /**
     * 新增新闻页面 + 修改新闻页面
     */
    @action savePage = async () => {
        runInAction(() => {
            this.loading = true
        })
        if (!this.forms.id) {
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/cms/page/add`, {
                ...this.forms
            })
            if (res && res.status >= 400) {
                message.error('新增失败')
                return
            } else {
                runInAction(() => {
                    this.modal = 'hide'
                    message.success('保存新闻页面成功')
                    this.forms = {}
                    this.loading = false
                })
                this.initListPage(this.page)
            }
        }else {
            const res = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/cms/page/update`, {
                ...this.forms
            })
            if (res && res.status >= 400) {
                message.error('修改新增失败')
                return
            } else {
                runInAction(() => {
                    this.modal = 'hide'
                    message.success('修改新闻成功')
                    this.forms = {}
                    this.loading = false
                })
                this.initListPage(this.page)
            }
        }
    }

    /**
     * 平行化表单，传值给form
     */
    @computed
    get fields() {
        let fields = {
            id: {value: this.forms.id},
            name: {value: this.forms.name}
        }
        return fields
    }

    /**
     * 将表单时对象化，绑值给store。form
     */
    @action.bound
    onFormsChange = (changedFields) => {
        const fields = {...this.fields, ...changedFields}
        let forms = {
            id: fields.id.value,
            name: fields.name.value
        }
        this.forms = forms
    }

    /**
     * 初始化表单，可以不传参数，初始化全部为 null
     * @param id 根据id查询
     */
    @action initEdit = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        if (!id) {
            runInAction(() => {
                this.forms = {}
                this.loading = false
                this.modal = 'show'
            })
        } else {
            const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/cms/page/id/${id}`)
            if (res && res.status === 0) {
                return
            }
            if (this.initModul && window.tinymce.activeEditor) {
                window.tinymce.activeEditor.setContent(res.content)
            } else {
                runInAction(() => {
                    this.initModul = true
                })
            }
            runInAction(() => {
                this.forms = res
                this.loading = false
                this.modal = 'show'
            })
        }
    }

    /**
     * 删除
     */
    @action
    deletePageId = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.batchDelete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/cms/page/delete?id=${id}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.loading = false
            message.success('删除成功')
        })
        this.initListPage(this.pagination.page - 1)
    }

    /**
     * 每次更新search框时，回写数据
     * @param values search数据
     */
    @action
    onSearchFieldChange(values) {
        runInAction(() => {
            this.search = values
        })
    }

    /**
     * 清空forms
     */
    @action empetyForms = () => {
        runInAction(() => {
                this.forms = {}
                if (window.tinymce.activeEditor) {
                    window.tinymce.activeEditor.setContent('')
                }
            }
        )
    }

    /**
     *  有栏目的新闻也不能删除
     */
    @action existCategoryType = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/cms/category/PageId/${id}`)
        if (res && res.status === 0) {
            return
        } else {
            runInAction(() => {
                this.loading = false
            })
            return res.length
        }
    }
}
export default new CMSPageStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/CMS/CMSPage/store.js